import { useEffect, useState } from 'react';
import type { IGasPriceToPreview } from 'src/interfaces/gas-price.model';

export function useImage(gasPrice: IGasPriceToPreview, isSingleType: boolean) {
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    if (window.WP_REACT_IMG != null) {
      if (isSingleType) {
        setImage(window.WP_REACT_IMG.img.network);
      } else {
        setImage(window.WP_REACT_IMG.img[gasPrice.type]);
      }
    }
  }, [gasPrice.type, isSingleType]);

  return image;
}
